import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { ConfigurationsPageCache } from 'models/interfaces/PageCache';
import P3Configuration from 'models/P3Configuration';

const GET_CONFIGURATIONS_PAGE_CACHE = gql`
  query GetConfigurationsPageCache {
    configurationsPageCache @client {
      tabOptions
      activeTab
      Assigned {
        name
        companyName
        campaign_status_id
        tgrams_id
        p3_configuration_id
        rank_points
        coverage_areas
        created_date
        configuration_status_id
        description
        start_date
        end_date
        p3_campaign_id
        preview_ads
        program_value
      }
      Unassigned {
        name
        p3_configuration_id
        rank_points
        coverage_areas
        created_date
        configuration_status_id
        description
        start_date
        end_date
        p3_campaign_id
        preview_ads
        program_value
      }
    }
  }
`;

interface ConfigurationsPageCacheContainerProps {
  children: (props: any) => any;
  configurations?: P3Configuration[];
}

interface ConfigurationsPageCacheQueryResults {
  configurationsPageCache: ConfigurationsPageCache;
}

//class ConfigurationsPageCacheQuery extends Query<ConfigurationsPageCacheQueryResults> {}

const ConfigurationsPageCacheContainer: React.FunctionComponent<
  ConfigurationsPageCacheContainerProps
> = ({ children, configurations }) => {
  return (
    <Query<ConfigurationsPageCacheQueryResults> query={GET_CONFIGURATIONS_PAGE_CACHE}>
      {({ data: { configurationsPageCache } = { configurationsPageCache: {} }, client }) => {
        const updateCache = async (data: any) => {
          await client.writeData({ data });
        };

        return children({
          configurationsPageCache,
          updateCache,
          client
        });
      }}
    </Query>
  );
};

export default ConfigurationsPageCacheContainer;
